import { Controller } from "@hotwired/stimulus"

// Sits on every game card (live or upcoming) and, for a referee session
// that has picked a game (see referee_game_select_controller.js), hides
// that card's action buttons if it isn't the chosen game — so a referee
// can see every field's score/cards but only ever touch their own.
//
// refresh() runs from two triggers: connect(), which Stimulus refires
// automatically whenever Game#broadcast_live_section swaps this element
// back into the DOM (same mechanic disclosure_memory_controller.js relies
// on), and the "referee-game-select:change" window event fired when the
// referee picks or resets their game — needed because switching selection
// doesn't touch the DOM of cards that were already on the page, so no
// connect() would fire for them on its own.
export default class extends Controller {
  static targets = ["controls"]
  static values = { gameId: String }

  connect() {
    this.refresh = this.refresh.bind(this)
    window.addEventListener("referee-game-select:change", this.refresh)
    this.refresh()
  }

  disconnect() {
    window.removeEventListener("referee-game-select:change", this.refresh)
  }

  refresh() {
    if (document.body.dataset.referee !== "true") return

    const selectedId = localStorage.getItem("lifSelectedGameId")
    const locked = !!selectedId && selectedId !== this.gameIdValue

    this.controlsTargets.forEach((el) => el.classList.toggle("hidden", locked))
  }
}
